import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import BackToTopButton from 'components/Generic/Buttons/BackToTopButton';
import findComponentInTree from 'lib/utils/findComponentInTree';
import { useEffect, useState } from 'react';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

const HelpArticleBody = ({ rendering }: ComponentProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();
  const [helpNextStepsComponent, setHelpNextStepsComponent] = useState(false);

  useEffect(() => {
    const routeData = sitecoreContext.route;
    if (routeData?.placeholders['abrdn-main']) {
      const helpNextSteps = findComponentInTree(
        routeData?.placeholders['abrdn-main'],
        'HelpNextSteps'
      );
      setHelpNextStepsComponent(!!helpNextSteps);
    }
  }, [sitecoreContext.route]);

  return (
    <div id={anchorId} data-e2e-component-uid={rendering.uid} className="container pt-5 pt-md-6">
      <div className="row d-flex justify-content-end flex-column flex-md-row article-body-wrapper">
        <div className="col-12 col-md-12 col-lg-3 mt-6 mt-md-0 abrdn-article-chapters-wrapper">
          <Placeholder name="abrdn-article-chapters" rendering={rendering} />
        </div>
        <div className="col-12 col-md-8 col-lg-6">
          <div className="abrdn-article-body d-flex flex-column">
            <Placeholder name="abrdn-article-body" rendering={rendering} articleBody={true} />
          </div>
          {sitecoreContext.helpArticleWildcardConfiguration?.showHelpNextSteps && (
            <Placeholder
              name="abrdn-help-article-next-steps"
              className="mt-5"
              rendering={rendering}
            />
          )}
        </div>
        <div className="col-12 col-md-4 col-lg-3 mt-6 mt-md-0">
          <div className="article-body__sidebar">
            {sitecoreContext.helpArticleWildcardConfiguration?.showRelatedHelpPlatform && (
              <Placeholder
                name="abrdn-help-article-related-help-platform"
                rendering={rendering}
                className={helpNextStepsComponent ? 'hide-on-mobile' : ''}
              />
            )}
            {sitecoreContext.helpArticleWildcardConfiguration?.showRelatedTaggedHelp && (
              <Placeholder
                name="abrdn-article-related-tag-help"
                rendering={rendering}
                helpArticlePlaceholder
              />
            )}
          </div>
        </div>
      </div>
      <BackToTopButton className="my-3 my-lg-4 d-flex justify-content-end" />
    </div>
  );
};

export default HelpArticleBody;
